import React from 'react';
import { Box, Button, Dialog, Typography } from '@mui/material';
import { formatCents } from '../money';
import { COLORS } from '../theme';

type Props = {
  open: boolean;
  lineCount: number;
  total: number;
  onCancel: () => void;
  onConfirm: () => void;
};

/** Voiding the whole sale is destructive and un-undoable, so it asks.
 *  Single-line removal doesn't — that gets an undo snackbar instead,
 *  which is faster and less annoying mid-transaction. */
const ClearCartDialog: React.FC<Props> = ({
  open,
  lineCount,
  total,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <Box sx={{ p: 3 }}>
      <Typography sx={{ fontWeight: 700, fontSize: '1.3rem', mb: 1 }}>
        Clear this sale?
      </Typography>
      <Typography sx={{ color: COLORS.textMuted, mb: 3 }}>
        {lineCount} {lineCount === 1 ? 'item' : 'items'}, {formatCents(total)}.
        This can't be undone.
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant="contained"
          onClick={onCancel}
          autoFocus
          sx={{ flex: 1, py: 1.5, fontWeight: 700 }}
        >
          KEEP
        </Button>
        <Button
          variant="outlined"
          color="error"
          onClick={onConfirm}
          sx={{ flex: 1, py: 1.5, fontWeight: 700 }}
        >
          CLEAR
        </Button>
      </Box>
    </Box>
  </Dialog>
);

export default ClearCartDialog;
